// 47283d: ONE sales document (credit note, goodwill credit, refund / payment voucher, return slip, payment receipt) in the SAME document modal the invoice uses (DocumentSheet): the
// server-built sheet (GET /sales-documents/:kind/:id/html -> { html, page, frame }) drawn on screen in the live document font; Print / Save PDF = the logged server PDF by id
// (Duplicata + print log), Verify for the correction credit note, Print log once issued. No PDF viewer iframe (Chrome's blob-PDF container is not reliable on every setup).
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../../services/api';
import DocumentSheet from './DocumentSheet';

export default function SalesDocSheet({ kind, id, highlight = '', onClose }) {
  const { t, i18n } = useTranslation('common');
  const lang = i18n.language && i18n.language.startsWith('fr') ? 'fr' : 'en';
  const [s, setS] = useState({ html: null, error: '' });
  useEffect(() => {
    let alive = true;
    api.getSalesDocumentHtml(kind, id, lang, highlight).then((d) => alive && setS({ ...d, error: '' })).catch((e) => alive && setS({ html: null, error: (e && e.message) || t('doc.pdfFailed') }));
    return () => { alive = false; };
  }, [kind, id, lang, highlight]);   // eslint-disable-line react-hooks/exhaustive-deps
  const issued = !!s.status && s.status !== 'draft';
  return (
    <DocumentSheet onClose={onClose} doc={{ type: kind, id }} paper={s.page} frame={s.frame} pdfFetch={(l) => api.getSalesDocumentPdf(kind, id, l, highlight)}
      verify={kind === 'avoir_correction' && issued ? { id, run: (l) => api.verifySalesDocument(kind, id, l) } : undefined} printLog={issued ? { kind, id } : undefined}>
      {s.error && <p style={{ color: 'var(--crit)' }} role="alert" data-testid="sales-doc-error">{s.error}</p>}
      {/* server-built from a trusted template; every value is HTML-escaped there (lib/salesDocHtml.js esc) */}
      {s.html && <div data-testid="sales-doc" dangerouslySetInnerHTML={{ __html: s.html }} />}
    </DocumentSheet>
  );
}
